import type { SourceSnapshot } from '@/model/sourceState/sourcestate.generated';

const POLL_ACTIVE_MS = 3_000;
const POLL_IDLE_MS = 30_000;

export function isSourceSyncing(source: SourceSnapshot): boolean {
  return (
    source.state.status === 'syncing' ||
    source.tables.some((table) => table.status === 'syncing') ||
    source.result_tables.some((table) => table.status === 'syncing')
  );
}

export function pollingIntervalFor(
  liveUpdates: boolean,
  active: boolean,
  awaitingRun: boolean,
): number {
  if (liveUpdates) return 0;

  return active || awaitingRun ? POLL_ACTIVE_MS : POLL_IDLE_MS;
}
